// PipelineMenu.jsx
import React, { useState, useRef } from 'react';
import Classes from '../../Workspace.module.css';
import { motion, AnimatePresence } from 'framer-motion';

const Eclipse = () => (
  <svg xmlns="http://www.w3.org/2000/svg" cursor='pointer' height="25px" viewBox="0 0 448 512">
    <path d="M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z" />
  </svg>
);

export default function PipelineMenu() {
  const [dropDown, setdropDown] = useState(false);
  const dropdownRef = useRef(null);

  return (
    <div className={Classes.dropDown} ref={dropdownRef}>
      <div onClick={() => setdropDown(!dropDown)}>
        <Eclipse />
      </div>

      <AnimatePresence>
        {dropDown && (
          <motion.div
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            className={Classes.dropDownBody}
          >
            <div className={Classes.dropDownBodyInner}>
              <div className={Classes.dropDownElem}>
                <h5>View order</h5>
              </div>

              <div className={Classes.dropDownLine}></div>

              <div className={Classes.dropDownElem}>
                <h5>Delete order</h5>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}